import React, { useEffect } from "react";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonImg,
  IonIcon,
  IonSpinner,
  IonText,
  IonButton,
  IonToast,
  IonDatetime,
  IonItem,
  IonLabel,
  IonInput,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonContent,
} from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLatestNews,
  fetchEvents,
  fetchStocks,
  addCommunityEvent,
} from "../../redux/actions/canadaNowActions";
import "./CanadaNow.css";
import { useState } from "react";
import { useRef } from "react";

const NewsCard = () => {
  const { news, loading } = useSelector((state) => state.canadaNow);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!news) {
      dispatch(fetchLatestNews());
    }
  }, [dispatch, news]);

  useEffect(() => {
    if (!news || news.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % news.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [news]);

  if (loading && !news) return <IonSpinner />;
  if (!news) return null;
  const currentNews = news[currentIndex];

  // const currentNews = Array.isArray(news) ? news[0] : null;

  if (!currentNews) return null;

  return (
    <IonCard
      className="canada-now-card ion-no-margin ion-shadow-md"
      style={{ borderRadius: "20px" }}
      href={currentNews.link}
      target="_blank"
    >
      {currentNews.image && (
        <div
          style={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          <IonImg
            src={currentNews.image}
            alt={currentNews.title}
            style={{ objectFit: "cover", width: "100%" }}
          />
        </div>
      )}
      <IonCardContent className="canada-now-card-content">
        <IonText
          style={{
            color: "#646464",
          }}
        >
          <h2 style={{ fontWeight: "bold", fontSize: "1.3rem" }}>🗞️ News</h2>
        </IonText>
        <IonText color="dark">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "19px",
              // height: "105px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 5,
              WebkitBoxOrient: "vertical",
            }}
          >
            {currentNews.title}
          </p>
        </IonText>
        <IonText>
          <p style={{ fontSize: "14px" }}>
            {format(new Date(currentNews.pubDate), "dd MMM")} · Global News
          </p>
        </IonText>
      </IonCardContent>
    </IonCard>
  );
};

const EventCard = ({ city = "Vancouver" }) => {
  const { events, loading } = useSelector((state) => state.canadaNow);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // --- MODAL & FORM STATE ---
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState({ show: false, message: "" });
  const [currentIndex, setCurrentIndex] = useState(0);
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");

  const [newEvent, setNewEvent] = useState({
    name: "",
    date: new Date().toISOString(),
    city: "",
    venue: "",
  });
  useEffect(() => {
    if (!events) {
      dispatch(fetchEvents(city));
    }
  }, [dispatch, events, city]);
  // Rotate events
  useEffect(() => {
    if (events && events.length > 1 && !showModal) {
      const timer = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % events.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [events, showModal]);

  // --- HANDLERS ---
  const handleInputChange = (e, field) => {
    setNewEvent({ ...newEvent, [field]: e.detail.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleAddEvent = async () => {
    const { name, date, city: eventCity, venue } = newEvent;

    if (!name || !date || !eventCity || !venue || !selectedFile) {
      setShowToast({
        show: true,
        message: t("allFieldsRequired", "Please fill in all fields."),
      });
      return;
    }
    if (name.length < 2 || name.length > 100) {
      setShowToast({
        show: true,
        message: "Event name must be between 3 and 100 characters",
      });
      return;
    }
    const formData = new FormData();
    formData.append("name", name);
    formData.append("date", date);
    formData.append("city", eventCity);
    formData.append("venue", venue);
    formData.append("image", selectedFile);

    try {
      await dispatch(addCommunityEvent(formData)).unwrap();
      setShowModal(false);
      setNewEvent({
        name: "",
        date: new Date().toISOString(),
        city: city,
        venue: "",
      });
      setSelectedFile(null);
      setPreviewUrl("");
      setShowToast({ show: true, message: "Event created successfully!" });
    } catch (err) {
      setShowToast({ show: true, message: "Failed to create event." });
    }
  };

  if (loading && !events) return <IonSpinner />;
  if (!events || !events.length) return null;

  const event = events[currentIndex];
  return (
    <>
      <IonCard
        className="canada-now-card events-now-card ion-no-margin ion-shadow-md"
        style={{ borderRadius: "20px" }}
        href={event.url}
        target="_blank"
      >
        {event.image && (
          <div
            style={{
              position: "relative",
              overflow: "hidden",
            }}
          >
            <IonImg
              src={event.image}
              alt={event.name}
              style={{ width: "100%", objectFit: "cover" }}
            />
          </div>
        )}
        <IonCardContent className="canada-now-card-content">
          <IonText
            style={{
              color: "#646464",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%", // <--- Add this
            }}
          >
            <h2 style={{ fontWeight: "bold", fontSize: "1.3rem" }}>
              📅 Events
            </h2>
            <IonButton
              style={{ "--background-color": "#d32f2f" }}
              size="small"
              onClick={(e) => {
                e.preventDefault(); // Prevent card click
                setShowModal(true);
              }}
            >
              + Add Event
            </IonButton>
          </IonText>
          <div style={{ flex: 1, paddingTop: "10px" }}>
            <IonText color="dark">
              <p style={{ fontWeight: "bold", fontSize: "19px" }}>
                {event.name}
              </p>
            </IonText>
          </div>
          <IonText style={{ marginTop: "auto" }}>
            <p style={{ fontSize: "14px" }}>
              {format(new Date(event.date), "dd MMM")} · Show Pass
            </p>
            <p style={{ fontSize: "14px" }}>
              {event.venue?.street_name} {event.city}
            </p>
          </IonText>
        </IonCardContent>
      </IonCard>
      {/* --- ADD EVENT MODAL --- */}
      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{t("addNewEvent", "Add New Event")}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowModal(false)}>
                {t("close", "Close")}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding showpass-modal-content">
          <IonItem>
            <IonLabel position="stacked">
              {t("eventName", "Event Name")}
            </IonLabel>
            <IonInput
              value={newEvent.name}
              onIonChange={(e) => handleInputChange(e, "name")}
              placeholder="e.g. Local Tech Meetup"
            />
          </IonItem>
          <IonItem lines="none" className="image-upload-wrapper">
            <IonLabel position="stacked" className="image-upload-label">
              {t("posterImage", "Poster image")}
            </IonLabel>

            {/* Hidden native file input */}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              ref={fileInputRef}
              style={{ display: "none" }}
            />

            {/* Styled Ionic Button to trigger the hidden input */}
            <IonButton
              fill="outline"
              // color="danger"
              className="upload-image-btn"
              onClick={() => fileInputRef.current?.click()}
            >
              📷{" "}
              {newEvent.image
                ? t("changeImage", "Change Image")
                : t("chooseImage", "Choose Image")}
            </IonButton>

            {(previewUrl || newEvent.image) && (
              <img
                src={previewUrl || newEvent.image}
                alt="Preview"
                className="image-upload-preview"
                style={{
                  marginTop: "16px",
                  borderRadius: "8px",
                  maxHeight: "200px",
                }}
              />
            )}
          </IonItem>
          {/* Venue Name Input */}
          <IonItem>
            <IonLabel position="stacked">{t("venue", "Venue Name")}</IonLabel>
            <IonInput
              value={newEvent.venue}
              onIonChange={(e) => handleInputChange(e, "venue")}
              placeholder="e.g. Rogers Arena"
            />
          </IonItem>

          {/* City Input */}
          <IonItem>
            <IonLabel position="stacked">{t("city", "City")}</IonLabel>
            <IonInput
              value={newEvent.city}
              onIonChange={(e) => handleInputChange(e, "city")}
              placeholder="e.g. Vancouver"
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">{t("date", "Date & Time")}</IonLabel>
            <IonDatetime
              value={newEvent.date}
              onIonChange={(e) => handleInputChange(e, "date")}
              presentation="date-time"
            />
          </IonItem>
          <IonButton
            expand="block"
            // color="danger"
            className="ion-margin-top submit-event-btn"
            onClick={handleAddEvent}
            disabled={!newEvent.name || !newEvent.date}
          >
            {t("submit", "Submit Event")}
          </IonButton>
          {/* Toast Notification */}
          <IonToast
            isOpen={showToast.show}
            onDidDismiss={() => setShowToast({ ...showToast, show: false })}
            message={showToast.message}
            duration={3000}
            color="danger"
            buttons={[{ text: "OK", role: "cancel" }]}
          />
        </IonContent>
      </IonModal>

      <IonToast
        isOpen={showToast.show}
        onDidDismiss={() => setShowToast({ ...showToast, show: false })}
        message={showToast.message}
        duration={5000}
        color={showToast.message.includes("success") ? "success" : "danger"}
      />
    </>
  );
};

const StockCard = () => {
  const { stocks, loading } = useSelector((state) => state.canadaNow);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const stockList = [
    { symbol: "RY.TO", name: "Royal Bank of Canada" },
    { symbol: "TD.TO", name: "Toronto-Dominion Bank" },
    { symbol: "BNS.TO", name: "Bank of Nova Scotia" },
    { symbol: "BMO.TO", name: "Bank of Montreal" },
    { symbol: "CM.TO", name: "CIBC" },
    { symbol: "NA.TO", name: "National Bank of Canada" },
    { symbol: "ENB.TO", name: "Enbridge Inc." },
    { symbol: "CNQ.TO", name: "Canadian Natural Resources" },
    { symbol: "SU.TO", name: "Suncor Energy" },
    { symbol: "SHOP.TO", name: "Shopify Inc." },
    { symbol: "GIB-A.TO", name: "CGI Inc." },
    { symbol: "CNR.TO", name: "Canadian National Railway" },
    { symbol: "CP.TO", name: "Canadian Pacific Kansas City" },
    { symbol: "BCE.TO", name: "BCE Inc." },
    { symbol: "T.TO", name: "Telus" },
  ];

  useEffect(() => {
    if (!stocks) {
      const symbols = stockList.map((s) => s.symbol).join(",");
      dispatch(fetchStocks(symbols));
    }
  }, [dispatch, stocks]);
  // Rotate items every 6 seconds
  useEffect(() => {
    if (stocks && stocks.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % stocks.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [stocks]);

  if (loading && !stocks) return <IonSpinner />;
  if (!stocks) return null;

  // let current = null;
  // for (const stock of stockList) {
  //   const data = Array.isArray(stocks)
  //     ? stocks.find((d) => d.symbol === stock.symbol)
  //     : null;
  //   if (data && data.price !== null) {
  //     current = {
  //       name: stock.name,
  //       price: data.price,
  //       change: data.change,
  //       type: "stock",
  //       link: `https://ca.finance.yahoo.com/quote/${stock.symbol}`,
  //       history: data.history,
  //     };
  //     break;
  //   }
  // }
  const currentData = stocks[currentIndex];
  const stockMeta = stockList.find((s) => s.symbol === currentData.symbol) || {
    name: currentData.symbol,
  };

  const current = {
    ...currentData,
    name: stockMeta.name,
    link: `https://ca.finance.yahoo.com/quote/${currentData.symbol}`,
  };

  if (!current) return null;

  const isPositive = current.change && !current.change.startsWith("-");

  return (
    <IonCard
      className="canada-now-card ion-no-margin ion-shadow-md"
      style={{
        borderRadius: "20px",
        height: "300px",
      }}
      href={current.link}
      target="_blank"
    >
      <IonCardContent
        className="canada-now-card-content"
        style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
      >
        <IonCardTitle
          color="dark"
          style={{ fontSize: "1.1rem", fontWeight: "bold" }}
        >
          🍁 {current.name}
        </IonCardTitle>

        {current.price !== null ? (
          <>
            💰 ${current.price.toLocaleString()}{" "}
            <span
              style={{
                color: isPositive ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {isPositive ? "▲" : "▼"} {current.change}
            </span>
          </>
        ) : (
          "Data unavailable"
        )}
        <br />
        <span
          style={{ fontSize: "0.8rem", color: "#555", fontStyle: "italic" }}
        >
          TSX Stock
        </span>
        {current.history && (
          <Chart
            type="line"
            height={80}
            width="100%"
            series={[{ data: current.history }]}
            options={{
              chart: {
                sparkline: { enabled: true },
                animations: { enabled: true },
              },
              stroke: { curve: "smooth", width: 2 },
              colors: [isPositive ? "#2e7d32" : "#c62828"],
              tooltip: { enabled: false },
            }}
          />
        )}

        <IonText>
          <p style={{ fontSize: "14px" }}>TSX · Canada 🇨🇦</p>
        </IonText>
      </IonCardContent>
    </IonCard>
  );
};

const CanadaNow = () => {
  return (
    <div className="canada-now-wrapper">
      <div className="canada-now-header-container">
        <div className="canada-now-header-title">
          <span style={{ padding: "0 2px" }}>🇨🇦</span>
          <span>Canada Now</span>
        </div>

        <Link to="/home/local" className="canada-now-header-link">
          <span>See all</span>
          <IonIcon icon={chevronForward} />
        </Link>
      </div>
      <div className="canada-now-container">
        <NewsCard />
        <EventCard />
        <StockCard />
      </div>
    </div>
  );
};

export default CanadaNow;
